// -----------------------------------------------------------------------------
// Scripts for menu icon
// -----------------------------------------------------------------------------

$(document).ready(function () {

  $('.navbar-toggler').on('click', function () {
    $(this).toggleClass('active');
  });

});